import { render } from "./alertApp.vue?vue&type=template&id=032b6282"
import script from "./alertApp.vue?vue&type=script&lang=js"
export * from "./alertApp.vue?vue&type=script&lang=js"

import "./alertApp.vue?vue&type=style&index=0&id=032b6282&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__